import React from "react";
import { DateRangeFilter, type DateRangeFilterProps } from "./DateRangeFilter";
import { useReportDateLimits } from "../hooks/useReportDateLimits";

type Props = Omit<DateRangeFilterProps, "maxDate"> & {
  companyId?: string;
};

export function ReportDateRangeFilter({ companyId, ...props }: Props) {
  const { reportMaxYmd } = useReportDateLimits(companyId);
  return <DateRangeFilter {...props} maxDate={reportMaxYmd} />;
}